"use client"

import {ReactNode, useMemo} from "react";
import LinkedGoBackHeader from "@/app/components/common/go-back-header/LinkedGoBackHeader";
import {Tabs, TabsList, TabsTrigger} from "@/app/components/common/tab-selector/TabSelector";
import * as React from "react";
import {Link, usePathname} from "@/i18n/navigation";
import {AnchorLink} from "@/app/components/docs/AnchorLink";
import {DOCS_NAV} from "@/lib/utils/contants/docsNav";
import {useTranslations} from "next-intl";

interface IProps {
    children: ReactNode;
}

export default function DocsLayout({children}: IProps) {
    const pathname = usePathname();
    const t = useTranslations();

    const currentItem = useMemo(() => {
        return DOCS_NAV.find(i => i.href === pathname) || DOCS_NAV[0];
    }, [pathname])

    // The /docs hub renders its own heading and list, so the per-document chrome is skipped there.
    const isHub = pathname === '/docs';

    return (
        <div className={'p-[16px] md:p-[32px]'}>
            <div className={'flex justify-between'}>
                <div className={'flex-1 flex justify-center'}>
                    <div className={'max-w-[800px]'}>
                        {/* The back header renders its own h1, so the hub (which has one) goes without it. */}
                        {!isHub && (
                            <LinkedGoBackHeader title={t(currentItem.title)} className={'mb-[16px] md:hidden'}/>
                        )}
                        {!isHub && (<>
                            <h1 className={'text-[48px] leading-[120%] font-medium tracking-[-1.5px] text-white mb-[20px] hidden md:block'}>
                                {t(currentItem.title)}
                            </h1>

                            <Tabs className={'md:hidden w-[calc(100vw-32px)] overflow-x-scroll mb-[36px]'} value={pathname}>
                                <TabsList className={'min-w-fit w-full'}>
                                    {DOCS_NAV.map((i) => (
                                        <Link prefetch={false} className={'w-full mr-[4px] last:mr-0'} key={i.href} href={i.href}>
                                            <TabsTrigger value={i.href}
                                                         className={'text-nowrap px-[20px] text-left'}>{t(i.title)}</TabsTrigger>
                                        </Link>
                                    ))}
                                </TabsList>
                            </Tabs>

                            <p className={'text-[14px] leading-[143%] tracking text-light-gray mb-[36px]'}>
                                {t(currentItem.lastUpdated)}</p>
                        </>)}

                        {children}
                    </div>
                </div>
                <div className={'hidden md:block basis-[240px]'}>
                    <div className={'sticky top-[100px]'}>
                        <nav className={'flex flex-col'}>
                            {DOCS_NAV.map(({title, href}) => <AnchorLink key={title} href={href}
                                                                         label={t(title)}/>)}
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    )
}
